import { render, staticRenderFns } from "./CodesSelector.vue?vue&type=template&id=0f631a2a&scoped=true"
import script from "./CodesSelector.vue?vue&type=script&lang=js"
export * from "./CodesSelector.vue?vue&type=script&lang=js"
import style0 from "./CodesSelector.vue?vue&type=style&index=0&id=0f631a2a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f631a2a",
  null
  
)

export default component.exports